export default __webpack_public_path__ + "static/image2-28cc56eb9171e326b24c12d2fc85791c.jpeg";